import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { User } from 'app/core/user/user.types';
import { UserSimple } from 'app/shared';
import { map, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
    private _httpClient = inject(HttpClient);

    private _user = new ReplaySubject<UserSimple | null>(1);
    private _currentUser: UserSimple | null = null;


    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: UserSimple | null) {
        // Store the value in the local storage
        localStorage.setItem('user', JSON.stringify(value));

        this._currentUser = value;

        this._user.next(value);
    }

    get user$(): Observable<UserSimple | null> {
        return this._user.asObservable();
    }

    get user(): UserSimple | null {
        // Return cached value if available
        if (this._currentUser) {
            return this._currentUser;
        }

        // Fallback to localStorage
        const user = localStorage.getItem('user');
        if (user) {
            try {
                this._currentUser = JSON.parse(user);
                this._user.next(this._currentUser);
                return this._currentUser;
            } catch (e) {
                console.error('Error parsing user from localStorage', e);
            }
        }

        return null;
    }
}
